<template>
  <div :class="cssClasses">
    <h3>{{ title }}</h3>
    <icon
      :name="iconName"
      size="l" />
    <strong>
      <template v-if="showValues">
        {{ value }}
      </template>
      <span
        v-else
        class="hidden-value">
        *****
      </span>
    </strong>
    <div class="stats-box-footer">
      <span class="footer-title">{{ footerTitle }}</span>
      <span class="footer-value">
        <template v-if="showValues">
          {{ footerValue }}
        </template>
        <span
          v-else
          class="hidden-value">
          *****
        </span>
      </span>
      <span
        v-if="trend && showValues"
        class="footer-trend">
        <template v-if="parseFloat(footerValue) > 0">▲</template>
        <template v-if="parseFloat(footerValue) < 0">▼</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stats-box',
  props: {
    color: {
      default: 'primary',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    iconName: {
      default: '',
      type: String
    },
    value: {
      default: '',
      type: [String, Number]
    },
    footerTitle: {
      default: '',
      type: String
    },
    footerValue: {
      default: '',
      type: [String, Number]
    },
    minimalMode: {
      default: false,
      type: Boolean
    },
    showValues: {
      default: true,
      type: Boolean
    },
    trend: {
      default: false,
      type: Boolean
    },
    expanded: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    cssClasses () {
      return {
        'stats-box': true,
        'primary-color': this.color === 'primary',
        'success-color': this.color === 'success',
        'warning-color': this.color === 'warning',
        'info-color': this.color === 'info',
        'minimal-mode': this.minimalMode,
        'is-expanded': !!this.expanded
      };
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.stats-box {
  border-radius: $border-radius-small;
  padding: 3rem 3rem 4.2rem 3rem;
  position: relative;
  width: calc(50% - 1.25rem);

  &.is-expanded {
    margin-right: 0!important;
    width: 100%;
  }

  h3 {
    color: $color-light;
    font-size: 1.3rem;
    font-weight: 400;
    margin: 0;
    opacity: .66;
    text-transform: uppercase;
  }

  svg {
    fill: $color-light;
    opacity: .33;
    position: absolute;
    right: 2rem;
    top: 2rem;
  }

  strong {
    color: $color-light;
    font-size: 3.6rem;
    font-weight: 400;
    line-height: 2;
  }

  &-footer {
    border-top: 1px solid rgba(255, 255, 255, .2);
    bottom: 2rem;
    color: $color-light;
    font-size: 1.2rem;
    left: 2rem;
    margin: 0;
    position: absolute;
    padding: 1.5rem 1rem 0 1rem;
    right: 2rem;
    text-transform: uppercase;

    .footer-title {
      margin-right: .5rem;
    }

    .footer-trend {
      font-size: 1rem;
      margin-left: .5rem;
    }
  }

  &.primary-color {
    background: $color-primary;
  }

  &.success-color {
    background: $color-success;
  }

  &.warning-color {
    background: $color-warning;
  }

  &.info-color {
    background: $color-notice;
  }

  &:nth-child(1) {
    margin-bottom: 2.5rem;
    margin-right: 1.25rem;
  }

  &:nth-child(2) {
    margin-bottom: 2.5rem;
    margin-left: 1.25rem;
  }

  &:nth-child(3) {
    margin-right: 1.25rem;
  }

  &:nth-child(4) {
    margin-left: 1.25rem;
  }

  &.minimal-mode {
    padding: 2rem 2rem 1.5rem 10rem;

    &:after {
      background: $color-light;
      bottom: 1.5rem;
      display: block;
      content: "";
      left: 7.85rem;
      opacity: .33;
      position: absolute;
      top: 1.5rem;
      width: .1rem;
    }

    strong {
      line-height: 1;
    }

    svg {
      left: 2.5rem;
      right: auto;
      top: 50%;
      transform: translateY(-50%);
    }

    .stats-box-footer {
      display: none;
    }
  }

  .hidden-value {
    position: relative;
    top: 10%;
  }
}

@media (max-width: 1600px) {
  .stats-box {
    &.minimal-mode {
      strong {
        font-size: 2.8rem;
      }
    }
  }
}

@media (max-width: 1240px) {
  .stats-box {
    strong {
      font-size: 2.8rem;
    }

    &.minimal-mode {
      padding: 2rem 2rem 1.5rem 7rem;

      &:after {
        left: 5.8rem;
      }

      svg {
        left: 1.5rem;
      }

      strong {
        font-size: 2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/StatsBox.vue